var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy2 = function SvgCopy2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "none",
    viewBox: "0 0 13 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1E3D",
    d: "M9.333 0h-8C.597 0 0 .597 0 1.333v9.334h1.333V1.333h8zm2 2.667H4c-.737 0-1.333.596-1.333 1.333v9.333c0 .737.596 1.334 1.333 1.334h7.333c.737 0 1.334-.597 1.334-1.334V4c0-.737-.597-1.333-1.334-1.333m0 10.666H4V4h7.333z"
  })));
};
export default SvgCopy2;